import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'index',
    component: () =>
      import(/* webpackChunkName: "home" */ '@/views/index/Index.vue'),
    meta: {title: '登录',isNav:true}
  },
  {
    path: '/myOrder',
    name: 'myOrder',
    component: () =>
      import(/* webpackChunkName: "myOrder" */ '@/views/myOrder/MyOrder.vue'),
    meta: {title: '我的订单'}
  },
  {
    path: '/:catchAll(.*)',
    name: 'notFound',
    component: () => import('@/views/404/Index'),
    meta: { title: '404' }
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: 'active'
})

export default router
